// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qGjA","label":"styles_label__2wIGD"};